import { BREED_IDS } from '../data/breeds';
import { earn } from '../core/economy';
import { spawnEvent } from '../core/events';
import { checkBreedUnlocks } from '../core/requirements';
import type { EventKind, GoldenEffect } from '../core/types';
import { game } from './controller';
import { h } from './dom';

/** Developer panel (Ctrl+Shift+D or ?dev=1). Cheats for testing pacing and events. */

let panel: HTMLElement | null = null;

export function toggleDevPanel(): void {
  if (panel) {
    panel.remove();
    panel = null;
    game.speed = 1;
    return;
  }
  const btn = (label: string, fn: () => void) => h('button', { class: 'btn small secondary', type: 'button', onclick: () => { fn(); game.changed(); } }, label);
  const spawn = (kind: EventKind, golden?: GoldenEffect) => () => {
    spawnEvent(game.state, game.ctx(), kind, game.viewFlock().id, golden ? { golden } : {});
  };
  const away = (hours: number) => () => {
    game.state.wallAt -= hours * 3_600_000;
    game.resume();
  };
  const speedLabel = h('span');
  const setSpeed = (x: number) => { game.speed = x; speedLabel.textContent = ` now ×${x}`; };
  panel = h('div', { class: 'dev-panel' },
    h('h4', { text: 'Dev panel' }),
    h('div', { class: 'row' }, btn('+$1K', () => earn(game.state, 1e3)), btn('+$100K', () => earn(game.state, 1e5)), btn('+$10M', () => earn(game.state, 1e7)), btn('+$1B', () => earn(game.state, 1e9))),
    h('h4', { text: 'Speed' }),
    h('div', { class: 'row' }, btn('×1', () => setSpeed(1)), btn('×10', () => setSpeed(10)), btn('×100', () => setSpeed(100)), speedLabel),
    h('h4', { text: 'Spawn' }),
    h('div', { class: 'row' },
      btn('Golden', spawn('golden')), btn('Storm', spawn('golden', 'clickStorm')), btn('Silver', spawn('silver')),
      btn('Rainbow', spawn('rainbow')), btn('Rooster egg', spawn('roosterEgg')), btn('Yolk', spawn('yolkBurst')),
      btn('Shower', spawn('eggShower')), btn('Rotten', spawn('rotten')),
      btn('Broody', () => {
        for (const f of game.state.flocks) for (const b of f.boxes) if (b.hen && b.hen.layingUntil !== null) b.hen.layingUntil = 0;
      })),
    h('h4', { text: 'Time away' }),
    h('div', { class: 'row' }, btn('1h', away(1)), btn('6h', away(6)), btn('30h', away(30))),
    h('h4', { text: 'Unlocks' }),
    h('div', { class: 'row' }, btn('All breeds', () => { for (const id of BREED_IDS) if (!game.state.unlockedBreeds.includes(id)) game.state.unlockedBreeds.push(id); checkBreedUnlocks(game.state); }),
      btn('Bank +1h combo', () => { game.state.acceleratorBank += 3_600_000; })),
  );
  document.body.append(panel);
  setSpeed(game.speed);
}
